import React, { memo } from "react";
import { Flex, Text, Highlight, SimpleGrid, Show, Image } from "@chakra-ui/react";
import { listWhyData } from "@/constants/alohainfo-contants";
export default memo(function WhyComponent() {
   return (
      <>
         <Text
            mt={{ base: "40px", BREAK_PAD: "80px", BREAK_LPC: "144px" }}
            fontFamily={{ base: "Arial-BoldMT", BREAK_LPC: "Arial" }}
            fontSize={{ base: 24, BREAK_LPC: 34 }}
            textAlign="center">
            <Highlight query="Why" styles={{ color: "green.500" }}>
               Why is AlohaBots developed?
            </Highlight>
         </Text>
         <SimpleGrid
            mx={"auto"}
            w={{ base: "90%", BREAK_PAD: "740px", BREAK_LPC: "960px", BREAK_PC: "1280px" }}
            columns={1}
            zIndex={'10'}
            spacing={'24px'}
            mt={{ base: "29px", BREAK_LPC: "77px" }}>
            {listWhyData.map((item, index) => {
               return (
                  <Flex
                     key={item}
                     flexDir={'row'}
                     bgColor='#FFF'
                     borderRadius={{base:'20px',BREAK_LPC:'122px'}}
                     px={{base:'20px',BREAK_LPC:'120px'}}
                     py={'20px'}
                     boxShadow={'0px 16px 40px 0px rgba(0,0,0,0.04)'}
                     alignItems={{base:'flex-start',BREAK_LPC:'center'}}>
                     <Text
                        fontSize={{ base: 18, BREAK_LPC: 27 }}
                        w={{ base: "36px", BREAK_LPC: "62px" }}
                        h={{ base: "36px", BREAK_LPC: "62px" }}
                        borderRadius={"full"}
                        lineHeight={{ base: "36px", BREAK_LPC: "62px" }}
                        textAlign="center"
                        bgColor={'#F5FAFC'}
                        boxShadow={"0px 10px 50px 0px rgba(246,248,252,1)"}
                        fontFamily={"Arial-BoldMT"}
                        color={"green.500"}>
                        0{index + 1}
                     </Text>
                     <Text
                        fontSize={{ base: 16, BREAK_LPC: 20 }}
                        ml={{base:'10px',BREAK_LPC:'32px'}}
                        flex={1}
                        color={"#333"}>
                        {item}
                     </Text>
                     <Show above="BREAK_LPC"><Image ml={'42px'} boxSize={{base: '64px', BREAK_LPC: '108px'}} src={process.env.REACT_APP_PUBLIC_URL + "images/why_icon"+(index+1)+".webp"}/></Show>
                  </Flex>
               );
            })}
         </SimpleGrid>
      </>
   );
});
